export default __webpack_public_path__ + "static/media/UBI3.f0ad71b7.png";